import { Dialog ,Box,styled } from '@mui/material'
import React from 'react'
import EmptyChat from './chatt/EmptyChat'
import Menu from './menu/Menu'
import ChatBox from './chatt/ChatBox'
import Footers from './chatt/Footers'
import { useChatContex } from '../../contex/ChatContex'



function ChatDilog() {

    const DilogStyle={
        height:'95%',
       
        width:"100%",
        maxWidth:'100%',
        maxHeight:'100%',
        boxShadow:'none',
        overflow:'hidden',
       
     }
    
   const Components= styled(Box)`
   display:flex;

   `

const LeftComponent=styled(Box)`
min-width:450px;

`

const RightComponent=styled(Box)`
min-width:300px;
width:73%;
height:100%;
border-left:1px solid rgba(0,0,0,0.14);

`

const {PersonData}=useChatContex()



    return (
        <div>
          <Dialog
           open={true}
           PaperProps={{sx:DilogStyle}}
           hideBackdrop={true}
           maxWidth={'md'}
          >
            <Components>
                <LeftComponent>
                   <Menu/>
                </LeftComponent>


                <RightComponent>
                {
                  Object.keys(PersonData).length==0?<EmptyChat/>
                  :
                  <>
                     <ChatBox/>
                  </>
                }
                  
                 
                </RightComponent>
            </Components>
          </Dialog>
        </div>
    )
}

export default ChatDilog
